(function($) {
    $.widget("ca.caSelectWithInput", {
        options: {
            id: ''
        },

        _create : function() {
            var options = this.options;
            var select = this.element;
            var selectId = this.options.id;
            var wrapper = select.parent();
            var input = $('#' + selectId + '-input');

            wrapper.find('.chosen-results').on("click", function(){
                var newResult = wrapper.find('.chosen-single span').html();
                var otherValue = $("#" + selectId + " > option[value='']").html();
                if (newResult == otherValue) {
                    input.show();
                } else {
                    input.hide();
                }
            });
            wrapper.find('.chosen-results').trigger("click");
        }
    });
})(jQuery);